import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { ActionPopover } from 'components/Table/ActionTable';
import { showDateFormated } from 'utility/generic';

export function TableGeneric({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
  );

  const { globalFilter } = state;

  return (
    <>
      <GlobalFilter
        filter={globalFilter}
        setFilter={setGlobalFilter}
        urlNewItem={'/route/new'}
      />
      <Table responsive striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th scope='col' {...column.getHeaderProps()}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length !== 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '14px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Não há registros disponíveis, por gentileza faça uma venda!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export const SaleSuccessScreen = () => {
  const [sales, setSales] = useState([]);

  useEffect(() => {
    async function getData() {
      const data = await handleSendGeneric('/v1/sale', 'GET');
      if (data !== undefined) {
        setSales(data);
      }
    }

    getData();
  }, []);

  const cacheItemsDisabled = useMemo(() => sales, [sales]);

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'Nome',
        accessor: 'client.name',
      },
      {
        Header: 'Estado',
        accessor: 'client.state',
      },
      {
        Header: 'Cidade',
        accessor: 'client.city',
      },
      {
        Header: 'Total',
        accessor: 'total',
      },
      {
        Header: 'Última Atualização',
        accessor: 'lastUpdate',
        Cell: ({ cell: { value } }) => (
          <span>{`${showDateFormated(value)}`}</span>
        ),
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <ActionPopover
              urlEdit={'/sales/' + actionId}
              urlDelete={'/v1/sale/'}
              idDelete={actionId}
              listUpdate={setSales}
            />
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGeneric columns={columns} data={cacheItemsDisabled} />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
